// extracted by mini-css-extract-plugin
module.exports = {"newsSection":"index-module--newsSection--3d-a-","newsList":"index-module--newsList--1Ss2n","newsCard":"index-module--newsCard--KI2EP","newsTitle":"index-module--newsTitle--16oDs"};